// extracted by mini-css-extract-plugin
module.exports = {"columnHeaderWrapper":"SortColumnHeader_columnHeaderWrapper__3A-iJ","sortArrow":"SortColumnHeader_sortArrow__11qSh","arrowVisible":"SortColumnHeader_arrowVisible__1kfnR"};